import React, { useState } from "react";
import { AiOutlineDown, AiOutlineUp } from "react-icons/ai";
import logoBlack from "../assets/logo-black.png";

const faqs = [
  {
    category: "Account Management",
    questions: [
      {
        question: "How do I log in?",
        answer:
          "You can log in using OTP-based authentication. Enter your registered email or phone number, and you will receive a one-time password (OTP) valid for 3 minutes.",
      },
      {
        question: "Can I sign up for an account?",
        answer:
          "No, the app is invite-only. Access is granted to designated users by Conquer Life Co. on behalf of client companies.",
      },
      {
        question: "Can I reset my password?",
        answer: "No passwords are needed—the app uses OTP-based login.",
      },
      {
        question: "Can I delete my account?",
        answer:
          "No, users cannot delete accounts. If your association with a client or Conquer Life Co. ends, your account will be disabled and information retained for record-keeping.",
      },
      {
        question: "Can I update my email or phone number?",
        answer:
          "Yes, updating either will log out all sessions and require re-login.",
      },
      {
        question: "Can I update my name?",
        answer:
          "Name changes require admin approval to match verification records.",
      },
    ],
  },
  {
    category: "Profile & Settings",
    questions: [
      {
        question: "What profile details can I update?",
        answer:
          "You can update your profile image, email, phone number, address, and availability.",
      },
    ],
  },
  {
    category: "Connecting with Others",
    questions: [
      {
        question: "Can I chat with others in the app?",
        answer:
          "Chat is coming soon. You'll be able to message mentors, admins, and approved users. Messages may be monitored for compliance.",
      },
    ],
  },
  {
    category: "Privacy & Security",
    questions: [
      {
        question: "What should I do if my account is compromised?",
        answer: "Immediately email info@conquerlife.io for assistance.",
      },
    ],
  },
  {
    category: "Troubleshooting",
    questions: [
      {
        question: "Why can’t I log in?",
        answer:
          "(A) Check your email or phone number.\n(B) Use the OTP within 3 minutes.\n(C) Contact support if the issue persists.",
      },
      {
        question: "How do I report a bug or issue?",
        answer:
          "You can report any issues or bugs by using the 'Support Request' option in the app’s menu drawer. Our team will review and assist you as soon as possible.",
      },
    ],
  },
  {
    category: "Support",
    questions: [
      {
        question: "How do I contact customer support?",
        answer:
          "You can reach us directly from the app by opening the menu drawer and selecting the 'Support Request' option for any help related to the app. You can also use the 'Feedback' section to share your feedback or suggestions.",
      },
      {
        question: "Where can I find the Terms of Service and Privacy Policy?",
        answer: "They are available in the app’s main menu (drawer).",
      },
    ],
  },
  {
    category: "Content Usage & Rights",
    questions: [
      {
        question: "Can I share or reuse content from the app?",
        answer:
          "No. All content is owned by Conquer Life Co. and may not be shared outside the app without written permission. See our Terms and Privacy Policy for more details.",
      },
      {
        question: "Who owns the games and tools in the app?",
        answer: "All content is © 2025 Conquer Life Co. All rights reserved.",
      },
    ],
  },
];

const FAQ = () => {
  const [expandedCategory, setExpandedCategory] = useState(null);

  const toggleCategory = (index) => {
    setExpandedCategory(expandedCategory === index ? null : index);
  };

  return (
    <div style={styles.page}>
      {/* ✅ HEADER */}
      <div style={styles.header}>
        <img
          src={logoBlack}
          alt="Conquer Life Logo"
          style={styles.logo}
        />
        <h1 style={styles.headerTitle} className="text-big-heading">CONQUER LIFE BUSINESS</h1>
      </div>

      <div style={styles.container}>
        <h1 style={styles.heading} className="text-big-heading">Frequently Asked Questions</h1>
        {faqs.map((faq, index) => (
          <div key={index} style={styles.faqBox}>
            <button
              className="text-sub-heading"
              onClick={() => toggleCategory(index)}
              style={{
                ...styles.categoryButton,
                backgroundColor:
                  expandedCategory === index ? "#5EA5ED" : "#fff",
                color: expandedCategory === index ? "#fff" : "#333",
              }}
            >
              <span style={styles.category} className="text-heading">{faq.category}</span>
              {expandedCategory === index ? (
                <AiOutlineUp size={24} />
              ) : (
                <AiOutlineDown size={24} />
              )}
            </button>
            {expandedCategory === index && (
              <div style={styles.questionsWrapper}>
                {faq.questions.map((q, qIndex) => (
                  <div key={qIndex} style={styles.questionCard}>
                    <p style={styles.question} className="text-sub-heading">{q.question}</p>
                    <p style={styles.answer} className="text-body">{q.answer}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  page: {
    flex: 1,
    backgroundColor: "#FFFFFF",
  },
  header: {
    display: "flex",
    alignItems: "center",
    borderBottom: "1px solid black",
    height: "60px",
    padding: "0 15px",
    boxSizing: "border-box",
  },
  logo: {
    width: "40px",
    height: "40px",
    marginRight: "15px",
  },
  headerTitle: {
    fontSize: "26px",
    fontWeight: "bold",
    color: "black",
    margin: 0,
  },
  container: {
    padding: "2rem",
  },
  heading: {
    textAlign: "center",
    fontSize: "2.5rem",
    color: "#333",
    marginBottom: "2rem",
  },
  faqBox: {
    margin: "1rem 0",
    border: "1px solid #5EA5ED",
    borderRadius: "25px",
    overflow: "hidden",
    boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
  },
  categoryButton: {
    width: "100%",
    padding: "1rem",
    fontSize: "1.25rem",
    fontWeight: "bold",
    border: "none",
    textAlign: "left",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
  },
  category: {},
  questionsWrapper: {
    padding: "1rem",
    // backgroundColor: "#f9f9f9",
  },
  questionCard: {
    // backgroundColor: "#fff",
    padding: "1rem",
    borderRadius: "12px",
    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
    border: "1px solid #e0e0e0",
    marginBottom: "1rem",
  },
  question: {
    fontWeight: "600",
    color: "#333",
    marginBottom: "0.5rem",
  },
  answer: {
    whiteSpace: "pre-wrap",
    color: "#333",
  },
};

export default FAQ;
